// ═══════════════════════════════════════════════════════════════════
//  socle/hooks.js
//  Hooks partagés : détection mobile, CRUD générique.
// ═══════════════════════════════════════════════════════════════════

import { useCallback, useEffect, useState } from "react";
import { API_BASE, authHeaders } from "./api";
import { MOBILE_BREAKPOINT } from "./theme";

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < MOBILE_BREAKPOINT : false
  );
  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = (e) => setIsMobile(e.matches);
    setIsMobile(mq.matches);
    if (mq.addEventListener) mq.addEventListener("change", onChange);
    else mq.addListener(onChange);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", onChange);
      else mq.removeListener(onChange);
    };
  }, []);
  return isMobile;
}

// ── Hook CRUD générique ─────────────────────────────────────────────────
export function useCrud(token, endpoint) {
  const [items,setItems]=useState([]);
  const [loading,setLoading]=useState(true);
  const load=useCallback(async(qs="")=>{
    setLoading(true);
    try{ const r=await fetch(`${API_BASE}${endpoint}${qs}`,{headers:{Authorization:`Bearer ${token}`}}); const d=await r.json(); setItems(Array.isArray(d)?d:[]); }
    catch(e){ console.error("CRUD load",endpoint,e); setItems([]); }
    setLoading(false);
  }, [endpoint, token]);
  useEffect(()=>{ load(); },[load]);
  const create=async(body)=>{ const r=await fetch(`${API_BASE}${endpoint}`,{method:"POST",headers:authHeaders(token),body:JSON.stringify(body)}); if(!r.ok) throw new Error("create"); await load(); };
  const update=async(id,body)=>{ const r=await fetch(`${API_BASE}${endpoint}/${id}`,{method:"PUT",headers:authHeaders(token),body:JSON.stringify(body)}); if(!r.ok) throw new Error("update"); await load(); };
  const remove=async(id)=>{ const r=await fetch(`${API_BASE}${endpoint}/${id}`,{method:"DELETE",headers:{Authorization:`Bearer ${token}`}}); if(!r.ok) throw new Error("delete"); await load(); };
  return { items, loading, load, create, update, remove };
}
